import { z } from "zod";
// Local
import {
  invoiceFrequency,
  invoiceMethod,
  TaskGeneration,
} from "../../models/membership-template";

export type TemporaryTaskGeneration = TaskGeneration & { id: string };

/** For add/edit template pages
 *
 * ---
 * the taskGen component is actually the only dialog.. named DialogStates for lack of a better idea
 */
export type DialogStates = {
  pbi: boolean;
  renewalPBI: boolean;
  renewalTemplate: boolean;
  taskGen: boolean;
};

export const TemplateFormSchema = z.object({
  title: z.string().min(1).max(500),
  description: z.string().min(1).max(4000),
  invoiceMethod: z.enum(invoiceMethod),
  invoiceFrequency: z.enum(invoiceFrequency),
  automaticallyRenewMembership: z.boolean().optional(),
  automaticallyGenerateTasks: z.boolean().optional(),
  discount: z
    .number()
    .min(0)
    .max(100, {
      message: "Discount must be between 0 and 100",
    })
    .or(z.literal("").transform(() => 0)),
  defaultDuration: z.number(),
  automaticallyPayInvoice: z.boolean().optional(),
  automaticallySendInvoice: z.boolean().optional(),
});

export type TemplateFormState = z.infer<typeof TemplateFormSchema>;
